<template>
  <div class="pa-4 background">
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{message}}</span>
    </v-snackbar>
    <v-card class="neu-glow pa-4">
        <v-card-title primary-title>
          <div class="text-h5">Pasti <span class="text-caption">(Selezionabili dal Cliente)</span></div>
          <v-spacer></v-spacer>
          <v-div>
            
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop="editItem(null)">
                  <v-icon color="info">mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Aggiungi</span>
            </v-tooltip>
            
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                           
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-div>           
        </v-card-title>
        <!--
        <v-row v-if="loading">
            <v-col class="text-center px-4">
              <v-progress-linear
                color="info"
                height="10"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
        </v-row>
        -->
        <div class="mx-4">
          <v-data-table
            fixed-header
            :headers="headers"
            :items="items||[]"
            hide-default-footer
            :items-per-page=500
            :item-class="itemClass"
            :loading="loading||loading_refresh"
            no-data-text="Nessun dato presente in archivio"
            no-results-text="Nessun Risultato estratto"
            loading-text="Consultazione archivio: attendi..."
          >
              <template v-slot:[`item.remarks`]="{ item }">
                <v-tooltip top max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="editItem(item)" icon v-bind="attrs" v-on="on" class="float-left">
                      <v-icon color="success">mdi-message-text</v-icon>
                    </v-btn>
                  </template>
                  <span v-html="item.remarks"></span>
                </v-tooltip>                        
              </template>

              <template v-slot:[`item.active`]="{ item }">
                <v-simple-checkbox
                  v-model="item.active"
                  color="info"
                  style="pointer-events: none"
                ></v-simple-checkbox>
              </template>

              <template v-slot:[`item.icon`]="{ item }">
                <v-icon>{{item.icon}}</v-icon>
              </template>
              <template v-slot:[`item.waIcon`]="{ item }">
                <div>{{item.waIcon}}</div>
              </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs" 
                      v-on="on"
                      color="warning"
                      class="mr-2"
                      @click="editItem(item)"
                    >
                      mdi-pencil
                    </v-icon>                
                </template>
                <span>Modifica</span>
              </v-tooltip>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs" 
                      v-on="on"
                      color="error"
                      class="mr-2"
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>                
                </template>
                <span>Elimina</span>
              </v-tooltip>
            </template>
            -->
          </v-data-table>
<!--
            <v-col cols="9" md="7"  :key="fi">
              <vue-editor :id="fi" v-model="f.A" :editorToolbar="customToolbar"  class="mx-2"  />
            </v-col>
            <v-col cols="3" md="1" :key="fi">
              <v-btn class="ml-1" block @click="editFaq(f)" color="red">Modifica</v-btn>
            </v-col>
            -->
      </div>
    </v-card>
    <v-dialog v-model="dialog_edit" max-width="600" class="pb-3" v-if="editedItem">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              {{editedItem.value?'Modifica Pasti':'Crea Pasti'}}
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :disabled="hash==JSON.stringify(editedItem)||!editedItem.meal" :loading="loading_update" @click="saveItem('save')">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip top >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialog_edit=false" fab small class="neu-glow" :disabled="hash!=JSON.stringify(editedItem)"  v-bind="attrs" v-on="on">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1 mb-0 pb-3">
                <v-col cols="6">
                  <v-text-field            
                    counter
                    label="Nome"
                    outlined
                    v-model="editedItem.name"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    label="Pasto"
                    outlined
                    :items="['lunch','dinner']"
                    v-model="editedItem.meal"
                    persistent-placeholder
                    hint="Scegli il pasto più adatto"
                    :loading="loading_refresh"
                  >
                  </v-select>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="Cut Off"
                    outlined
                    reverse
                    type="number"
                    v-model="editedItem.cutOffMinutes"
                    persistent-placeholder
                    hint="Minuti di anticipo chiusura prenotazioni"
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>                                
                <v-col cols="4">
                  <v-text-field
                    label="Ordinamento"
                    outlined
                    reverse
                    type="number"
                    v-model="editedItem.sortOrder"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>
                <v-col cols="4" v-show="editedItem.value" class="d-flex justify-center">
                  <v-switch
                      v-model="editedItem.active"
                      inset
                      :label="editedItem.active?'Attiva':'Non Attiva'"
                  ></v-switch>
                </v-col>                                                   
            </v-row>
            <!--
            <v-divider class="my-3"></v-divider>
            <v-card-actions>
                <v-btn color="info"  @click="dialog_edit = false">
                  Esci
                </v-btn>         
                <v-spacer></v-spacer>
                <v-btn color="success" :loading="loading_update" @click="saveItem('save')">
                  Salva
                </v-btn>
            </v-card-actions>
            -->
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_delete" max-width="420px">
        <v-card>
            <v-card-title class="text-h6">
              Confermi Cancellazione?
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  @click="saveItem('delete')">
                      <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                  </template>
                  <span>Si, Confermo</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_delete=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>No, Esci</span>
              </v-tooltip>              
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-alert
                color="red"
                icon="mdi-alert"
                type="success"
                dismissible
              >
              <span class="font-weight-bold">Attenzione!</span><br>Cancellando un pasto, vengono cancellati anche i Turni ad esso collegati ed anche tutti gli slot riferibili ai Turni cancellati.
              </v-alert>
              <div class="pt-3">Si consiglia di evitare di cancellare Pasti per poi crearne di nuovi: utilizzare quelli esistenti, eventualmente modificandone i parametri.</div>
            </v-card-text>
        </v-card>
    </v-dialog>       
    <dialog-instruction v-model="dialog_instruction" />    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import dialogInstruction      from "../Dialogs/instruction_allMealsTables";
//import _ from 'lodash'
export default {
    components:{
      dialogInstruction
    },
    props:['value'],  
  data() {
    return {
      page: "Settings",
      dialog_edit:false,
      dialog_delete:false,
      dialog_instruction:false,
      loading:false,
      snackbar:false,
      snackbar_color:'success',
      message:null,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      items:[],
      hash:null,      
      editedItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      emptyItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      loading_refresh:false,
      headers: [
                { text: 'Ord.',         value: 'sortOrder',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Nome',         value: 'text',          align: 'start',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'Pasto',        value: 'meal',          align: 'start',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'CutOff',       value: 'cutOffMinutes', align: 'center',  sortable: false, class:'pl-1 text-lg-button' },                
                { text: 'Attiva',       value: 'active',        align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Azione',       value: 'actions',       align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],

    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
  },
  methods:
  {
    editItem(f)
    {
      if (f) 
      {
        this.editedItem=f;
      }
      else{
        this.editedItem={...this.emptyItem};
        this.editedItem.active=1;
      }
      console.log(214,f)
      this.hash=JSON.stringify(this.editedItem);
      this.dialog_edit=true;
    },
    deleteItem(f)
    {
      this.editedItem=f;
      console.log(214,f)
      this.dialog_delete=true;
    },    
    async saveItem(a)
    {
        console.log(144,this.editedItem);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        if(a=='delete')
        {
          action='deleteItem'
          this.editedItem.erase=1;
        }
        else
        {
          action='saveItem';
        }
        let payload={"action":action,"table":"Meals","payload":JSON.stringify(this.editedItem)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.payloads.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.$root.$emit('onupdateMeals', null);
        }   
        this.editedItem={...this.emptyItem}
    },
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"action":"AllMealsTable_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.items=res.data.payloads.allMealsTable;
                    console.log(315,this.items)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.payloads.message;
            this.getData('refresh')

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.payloads.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
          console.log(e);
          this.loading= false;
          this.dialog_connection_error=true;
        }
    },
  },
};
</script>